import { Box, Button, Drawer, Typography, useTheme } from "@mui/material";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import { extractDateAndTimeFromDateText, formatTimestampText } from "../../utilities/shipmentTable";

const DATE_FIELDS = ["PickupEta", "PickupTime", "DeliveryEta", "DeliveryTime", "CustomerPortalDeliveryTime", "RescheduleDate"];

const FIELD_NAMES_MAPPER = {
    PickupEta: "Pick-up ETA",
    PickupTime: "Pick-up Time",
    DeliveryEta: "Delivery ETA",
    DeliveryTime: "Manual Delivery Time",
    CustomerPortalDeliveryTime: "Customer Portal Delivery Time",
    RescheduleDate: "Reschedule Date",
    Notes: "Notes",
    ReasonCode: "Reason Code",
    Criticality: "Criticality",
};

export const AuditHistory = ({ isLoading, handleClosePopup, shipmentHistory = [] }) => {
    const theme = useTheme();

    const formatValue = (key, value) => (DATE_FIELDS.includes(key) && value) ? formatTimestampText(value) : (value || "");

    return (
        <Drawer
            anchor="right"
            open={true}
            onClose={handleClosePopup}
            PaperProps={{
                sx: {
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                },
            }}
        >
            <Box
                sx={{
                    width: 493,
                    height: "100%",
                    overflow: "auto",
                }}
            >
                {/* header */}
                <Box sx={{margin: "15px",}}>
                    <Typography
                        sx={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "24px",
                            letterSpacing: "0.5px",
                            textAlign: "left",
                            gap: 10,
                            height: 24,
                            color: theme.palette.text.primary,
                        }}
                        variant="h6"
                        gutterBottom
                    >
                        Shipment Record
                    </Typography>
                    
                </Box>

                {/* Body content */}
                <Box
                    sx={{
                        marginLeft:"20px",
                        borderLeft: shipmentHistory.length ? `2px solid ${theme.palette.breadcumb.primary}` : "none",
                    }}
                >
                    { 
                        !!shipmentHistory.length &&
                        <Box sx={{paddingLeft: 2}}>
                            <Box style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                            >
                                <div style={{
                                    height: "16px",
                                    width: "16px",
                                    marginRight: "10px",
                                    border: `4px solid ${theme.palette.mode === "dark" ? "#FFFFFF" : "#006098"}`,
                                    borderRadius: "10px",
                                }}
                                />
                                <Typography
                                    sx={{
                                        fontFamily: "Poppins",
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        letterSpacing: "0.5px",
                                        color: theme.palette.text.primary,
                                    }}
                                    variant="h6"
                                >
                                    Recent Update
                                </Typography>
                            </Box>

                            <ul style={{paddingLeft: 0, margin: 0}}>
                                {shipmentHistory.map((history, index) => (
                                    <Box
                                        key={"audit-item-" + index}
                                        sx={{
                                            borderBottom: "1px solid #E8F2FF",
                                            marginRight: "20px",
                                            paddingTop: "4px",
                                            paddingBottom: "4px",
                                            paddingLeft: "25px",
                                        }}
                                    >
                                        <li style={{
                                            listStyleType: index === 0 ? "none" : "disc",
                                            color: theme.palette.text.button,
                                            fontSize: "24px",
                                            lineHeight: "6px",  
                                        }}
                                        >
                                            <Box 
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "start",
                                                    alignItems:  "center",
                                                    paddingRight: "2px",
                                                }}
                                            >
                                                <Box style={{display:"flex", alignItems: "center", height: "30px"}}>
                                                    <CalendarTodayIcon sx={{
                                                        height: "16px",
                                                        width: "16px",
                                                        marginRight: "2px",
                                                        color:  theme.palette.text.primary,
                                                    }}/>
                                                    <Typography
                                                        sx={{
                                                            fontFamily: "Poppins",
                                                            fontSize: "14px",
                                                            fontWeight: 400,
                                                            letterSpacing: "0.5px",
                                                            color: theme.palette.text.primary,
                                                            marginLeft: "4px",
                                                            paddingTop: "6px",
                                                        }}
                                                        variant="h6"
                                                        gutterBottom
                                                    >
                                                        {extractDateAndTimeFromDateText(history.UpdatedTime)?.date}
                                                    </Typography>
                                                </Box>

                                                <Box style={{display:"flex", alignItems: "center", height: "30px", marginLeft: "15px"}}>
                                                    <PersonIcon sx={{height: "18px", width: "18px", color:  theme.palette.text.primary,}} />
                                                    <Typography
                                                        sx={{
                                                            fontFamily: "Poppins",
                                                            fontSize: "14px",
                                                            fontWeight: 400,
                                                            letterSpacing: "0.5px",
                                                            color: theme.palette.text.primary,
                                                            marginLeft: "4px",
                                                            wordBreak: "break-word",
                                                        }}
                                                        variant="h6"
                                                    >
                                                        {history.UpdatedBy} <span style={{color: "#72777F"}}>Edited</span>
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    sx={{
                                                        fontFamily: "Poppins",
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                        lineHeight: "24px",
                                                        letterSpacing: "0.5px",
                                                        color: theme.palette.text.primary,
                                                        wordBreak: "break-all",
                                                    }}
                                                    variant="h6"
                                                    gutterBottom
                                                >
                                                    {FIELD_NAMES_MAPPER[history.key] || history.key}: {formatValue(history.key, history.value)}
                                                </Typography>
                                                
                                            </Box>
                                            <Box style={{display:"flex", alignItems: "center", marginBottom: "4px"}}>
                                                <Typography
                                                    sx={{
                                                        fontFamily: "Poppins",
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                        lineHeight: "24px",
                                                        textAlign: "center",
                                                        letterSpacing: "0.5px",
                                                        color: theme.palette.text.primary,
                                                    }}
                                                    variant="h6"
                                                >
                                                    At
                                                </Typography>
                                                <WatchLaterIcon sx={{height: "14px", width: "14px", marginLeft: "4px", marginRight: "2px", color:  theme.palette.text.primary,}} /> 
                                                <Typography
                                                    sx={{
                                                        fontFamily: "Poppins",
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                        lineHeight: "24px",
                                                        letterSpacing: "0.5px",
                                                        color: theme.palette.text.primary,
                                                    }}
                                                    variant="h6"
                                                >
                                                    {extractDateAndTimeFromDateText(history.UpdatedTime)?.time}
                                                </Typography>
                                            </Box>
                                        </li>
                                    </Box>
                                ))}
                            </ul>
                        </Box>
                    }

                    {/* no shipments case content */}
                    {
                        !shipmentHistory.length && <Box
                            sx={{
                                width:"100%",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {isLoading ? "Loading..." : "No History Found."}
                        </Box>
                    }
                </Box>
                
            </Box>

            {/* bottom section */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "end",
                    alignItems: "center",
                    padding: "20px",
                    marginTop: "auto",
                }}
            >
                <Button
                    variant="text"
                    sx={{
                        textTransform: "none",
                        color: theme.palette.text.primary,
                        fontFamily: "Poppins, sans-serif",
                    }}
                    onClick={handleClosePopup}
                >
                    Close
                </Button>
            </Box>
        </Drawer>
    );
};